import { validateEvidenceLabConfig, type EvidenceLabConfig } from '../minigames/evidence-lab/EvidenceLabConfig.js';

export const WEATHER_WATCH_INVESTIGATION: EvidenceLabConfig = {
  id: 'weather-watch-pattern-1', skillId: 'science-weather-patterns-1',
  question: 'What pattern happened as rain moved toward the station?',
  subjects: [
    { id: 'morning-one', label: 'MORNING 1', observation: 'Thin white clouds. Temperature: 68°F. No rain collected.', evidenceId: 'thin-warm-dry' },
    { id: 'morning-two', label: 'MORNING 2', observation: 'Thicker gray clouds. Temperature: 60°F. A few drops collected.', evidenceId: 'thick-cool-drops' },
    { id: 'morning-three', label: 'MORNING 3', observation: 'Dark low clouds. Temperature: 55°F. Steady gentle rain collected.', evidenceId: 'dark-cool-rain' },
  ],
  conclusions: [
    { id: 'clear-warmer', text: 'Skies cleared and warmed as rain increased.' },
    { id: 'cloudy-cooler', text: 'Clouds thickened and temperature fell as rain increased.' },
    { id: 'same-each-day', text: 'Clouds, temperature, and rain stayed the same.' },
  ],
  correctConclusionId: 'cloudy-cooler', requiredEvidenceIds: ['thin-warm-dry', 'thick-cool-drops', 'dark-cool-rain'],
  hints: ['Record all three mornings before comparing.', 'Compare cloud thickness, temperature, and rain together.', 'From Morning 1 to Morning 3, clouds grew darker, temperature fell, and more rain appeared.'],
  evidenceExplanation: 'All three records show thicker clouds and cooler temperatures as the gentle rain increased.',
  successMessage: 'The weather beacon glows! Careful records revealed the pattern.', restorationEvent: 'weather-watch-beacon-restored',
};
validateEvidenceLabConfig(WEATHER_WATCH_INVESTIGATION);
